import DeleteCalendarEventResponse from 'owa-service/lib/contract/DeleteCalendarEventResponse';
import deleteCalendarEventsAndNotify from '../store/apis/deleteCalendarEventsAndNotify';
import deleteCalendarEventsByInstanceKeysAndNotify from '../store/apis/deleteCalendarEventsByInstanceKeysAndNotify';
import EventScope from 'owa-service/lib/contract/EventScope';
import getCalendarEventForEventId from './getCalendarEventForEventId';
import getItemIdToUpdate from 'mini-calendar-event-services/lib/utils/getItemIdToUpdate';
import { CalendarEvent } from 'mini-calendar-event-types';
import { ClientItemId } from 'owa-client-ids';
import { deleteCalendarEventService } from 'mini-calendar-event-services/lib/services/deleteCalendarEventService';

/**
 * Deletes the calendar event from the server based on id
 * @param calendarEventId Id of the event that we want to delete
 * @param eventScope The scope/instance of event(like single instance, series, etc.)
 * @param isLocalDeleteOnly if true, will perform only local cache delete without performing service calls
 * @returns Returns the status of delete operation, a true is success, false for failure.
 */
export default async function deleteCalendarEvent(
    calendarEventId: ClientItemId,
    eventScope: EventScope,
    isLocalDeleteOnly: boolean = false
): Promise<DeleteCalendarEventResponse> {
    const { Id: id, mailboxInfo } = calendarEventId;
    let responseBody: DeleteCalendarEventResponse;
    if (!isLocalDeleteOnly) {
        const baseItemId = getItemIdToUpdate(id, eventScope);
        // Invoke the service to delete the event
        responseBody = await deleteCalendarEventService(baseItemId, mailboxInfo, eventScope);
    }

    if (responseBody?.ResponseClass === 'Success' || isLocalDeleteOnly) {
        const eventDeleted: CalendarEvent = getCalendarEventForEventId(id);
        if (eventDeleted) {
            if (eventScope === EventScope.AllInstancesInSeries) {
                deleteCalendarEventsByInstanceKeysAndNotify([eventDeleted.InstanceKey]);
            } else {
                deleteCalendarEventsAndNotify([eventDeleted]);
            }
        }
    }
    if (isLocalDeleteOnly) {
        responseBody = { ResponseClass: 'Success', ResponseCode: 'NoLocalDeleteError' };
    }
    return Promise.resolve(responseBody);
}
